// Client-only Stripe.js loader. Safe to import from React components.
import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

type StripeEnv = "sandbox" | "live";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function getStripeEnvironment(): StripeEnv {
  if (clientToken?.startsWith("pk_test_")) return "sandbox";
  if (clientToken?.startsWith("pk_live_")) return "live";
  throw new Error(
    "Stripe payments are not configured for this build. " +
      "Complete Stripe go-live in your Lovable project to enable production checkout.",
  );
}

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    getStripeEnvironment(); // throws if missing
    stripePromise = loadStripe(clientToken as string);
  }
  return stripePromise;
}

export function isStripeConfigured(): boolean {
  return Boolean(clientToken && (clientToken.startsWith("pk_test_") || clientToken.startsWith("pk_live_")));
}

export function isTestMode(): boolean {
  return Boolean(clientToken?.startsWith("pk_test_"));
}
